import { APICfg } from 'services/api/api'
import { APIBaseProduct } from '../baseProduct/types/api/response-models'
import { ProductSection, ProductSectionToAPI } from '../types'
import { productSectionParse } from '../utils'

type MusicSection = ProductSection<APIBaseProduct>

type MusicSectionToApi = ProductSectionToAPI

const apiCfg: APICfg = {
  endpoint: 'musicsections',
  parse: productSectionParse,
  write: async (req: MusicSection): Promise<MusicSectionToApi> => req,
}
export default apiCfg
